import React from "react";
import { Trash2 } from "lucide-react";
import { ProductColumnHeader } from "src/enums";
import { TableColumn, ChildPOProductInputField } from "src/types";
import { TextInputBox } from "src/components";
import { Table } from "src/components";

interface ChildPOProductInputTableProps {
  products: ChildPOProductInputField[];
  setProducts: React.Dispatch<React.SetStateAction<ChildPOProductInputField[]>>;
}

const ChildPOProductInputTable: React.FC<ChildPOProductInputTableProps> = ({ products, setProducts }) => {
  const handleProductChange = <T,>(id: string, fieldName: keyof ChildPOProductInputField, value: T) => {
    setProducts(products.map((product) => (product.fieldId === id ? { ...product, [fieldName]: value } : product)));
  };

  const childPOProductTableColumns: TableColumn<ProductColumnHeader, ChildPOProductInputField>[] = [
    {
      header: ProductColumnHeader.ID,
      column: (row) => (
        <div className="w-32">
          <TextInputBox
            id={`id-${row.fieldId}`}
            value={(products.find((product) => product.fieldId === row.fieldId)?.id ?? "").toString()}
            onChange={(value) => handleProductChange(row.fieldId, "id", value)}
            placeholder="Enter product ID"
            maxLength={15}
            size="sm"
          />
        </div>
      ),
      styles: { minWidth: "200px" }
    },
    {
      header: ProductColumnHeader.UK_QTY,
      column: (row) => (
        <div className="w-24">
          <TextInputBox
            id={`uk-quantity-${row.fieldId}`}
            value={(products.find((product) => product.fieldId === row.fieldId)?.ukQuantity ?? "").toString()}
            onChange={(value) => handleProductChange(row.fieldId, "ukQuantity", value)}
            placeholder="UK"
            maxLength={10}
            size="sm"
          />
        </div>
      ),
      styles: { minWidth: "120px" }
    },
    {
      header: ProductColumnHeader.EU_QTY,
      column: (row) => (
        <div className="w-24">
          <TextInputBox
            id={`eu-quantity-${row.fieldId}`}
            value={(products.find((product) => product.fieldId === row.fieldId)?.euQuantity ?? "").toString()}
            onChange={(value) => handleProductChange(row.fieldId, "euQuantity", value)}
            placeholder="EU"
            maxLength={10}
            size="sm"
          />
        </div>
      ),
      styles: { minWidth: "120px" }
    },
    {
      header: ProductColumnHeader.PLACE_HOLDER,
      column: (row) => (
        <button
          onClick={() => setProducts(products.filter((product) => product.fieldId !== row.fieldId))}
          disabled={products.length === 1}
          className="group flex items-center justify-center p-2 rounded-md hover:bg-error-50 transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent"
          title="Delete product"
          type="button"
        >
          <Trash2 className="w-4 h-4 text-error-600 group-hover:text-error-700 transition-colors" />
        </button>
      ),
      styles: { minWidth: "60px", textAlign: "center" }
    }
  ];

  return <Table<ProductColumnHeader, ChildPOProductInputField> data={products} columns={childPOProductTableColumns} />;
};

export { ChildPOProductInputTable };
